/**
 * Storage keys condivise con il frontend Easyflow: stesso browser, stessa
 * sessione tenant (il token emesso da `/api/:slug/login` è identico).
 * La deadline di inattività NON è qui: è di proprietà del motore condiviso
 * `session-idle` di `@easyflow/ui-frontend` (scope `tenant`).
 */
export const AUTH_STORAGE_KEYS = {
  TOKEN: 'edgvoip_tenant_token',
  REFRESH_TOKEN: 'edgvoip_tenant_refresh_token',
  USER: 'edgvoip_tenant_user',
  TENANT_SLUG: 'edgvoip_tenant_slug',
  /** `sessionPolicy` ricevuta da login/refresh (DTO `SessionPolicy`, secondi). */
  SESSION_POLICY: 'edgvoip_tenant_session_policy',
} as const;

export function clearAuthStorage(): void {
  Object.values(AUTH_STORAGE_KEYS).forEach((key) => {
    localStorage.removeItem(key);
  });
}
